import { HTMLStripper } from './html-stripper';
import { LanguageCode } from './languages';
import { MESSAGE_TYPE, MessageType } from './message-types';

export class CkEditorNewlineTrimmer {
  static trimMessage = (message: string) => {
    // First, make breaks new lines
    message = CkEditorNewlineTrimmer.trimBrs(message);

    // Then, remove any other HTML that might be injected by ckeditor
    message = HTMLStripper.strip(message) || message;

    // Finally, remove any extra whitespace from the beginning and end of the text
    message = message.trim();

    return message;
  };

  static trimBrs = (message: string) => message.replace(/<br \/>/g, '\n');

  // Do the opposite of what the trimBrs is doing - replace new lines with <br>'s so that ckeditor renders them correctly
  static untrimMessage = (message: string) => message.replace(/\n/g, '<br />');

  /**
   * Trims HTML and whitespace from every message in a map of language codes to messages
   * @param languageHash the map of LanguageCodes to messages to be trimmed
   * @param messageType email or text
   * @returns languageHash with all the messages trimmed
   */
  static getSimpleTrimmedHash = (
    languageHash: Record<LanguageCode, string>,
    messageType: MessageType,
  ) => {
    const simpleLanguageToMessage: { [key: string]: string } = {};
    const languagesEntered = Object.keys(languageHash);
    languagesEntered.forEach((key) => {
      let message = languageHash[key];
      if (messageType === MESSAGE_TYPE.TEXT) {
        message = CkEditorNewlineTrimmer.trimMessage(message);
        simpleLanguageToMessage[key] = message;
      } else {
        simpleLanguageToMessage[key] = message;
      }
    });

    return simpleLanguageToMessage;
  };
}
